// Wraps the routes so a render error leaves a way out instead of unmounting the
// whole app to a blank page — no top bar, no bottom bar, no message. The usual
// cause is a stale tab after a deploy (lib/staleBuild.ts): a lazy route's chunk
// is gone, and the one automatic reload is either on its way or already spent.
// React logs the caught error to the console itself.
import { Component, type ReactNode } from 'react';

import { staleBuild } from '../lib/staleBuild';

interface State {
  failed: boolean;
}

export class RouteErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    const { detected, reloading } = staleBuild;
    return (
      <main className="route-error" role="alert">
        <h1>{detected ? 'Neomaris was updated' : 'Something went wrong'}</h1>
        {reloading ? (
          <p>Loading the latest version…</p>
        ) : (
          <>
            <p>
              {detected ? 'Reload to get the latest version.' : 'Reload the page to try again.'}
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </>
        )}
      </main>
    );
  }
}
